import { Box, Typography, Button } from "@mui/material"
import Nav from "../Components/Nav/Nav"

const NotFound = () => {
  return (
    <>
      <Nav />
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "white",
          padding: 4,
        }}
      >
        <Typography variant="h2" gutterBottom>404</Typography>
        <Typography variant="h5" gutterBottom>Page not found</Typography>
        <Typography variant="body1" sx={{ marginBottom: 3, color: "var(--dark-600)" }}>
          The page you're looking for doesn't exist or may have moved.
        </Typography>
        <Button variant="contained" href="/">Back to Home</Button>
      </Box>
    </>
  )
}

export default NotFound
